export type Plan =
  | 'StaffedUp Service'
  | 'Service + Onboarding'
  | 'StaffedUp Enterprise';

type PricingOption = {
  title: Plan;
  pricePerMonth?: {
    Annually: string;
    'Semi-Annually': string;
    Monthly: string;
  };
  acctualBill?: {
    Annually: string;
    'Semi-Annually': string;
    Monthly: string;
  };
  benefits: string[];
};

export const pricingOptions: PricingOption[] = [
  {
    title: 'StaffedUp Service',
    pricePerMonth: {
      Annually: '$29/month',
      'Semi-Annually': '$34/month',
      Monthly: '$39/month',
    },
    acctualBill: {
      Annually: '$348 Yearly',
      'Semi-Annually': '$204 per 6 months',
      Monthly: 'No Contract'
    },
    benefits: [
      'Branded Hiring Platform',
      'Unlimited job postings',
      'Talent management',
      'Interview scheduling',
      'Social & Web Integration',
      'Fast, user-friendly interface',
      'Full Customization',
      'Hiring Analytics',
      'Hiring Automation',
      'Job Board Integration',
    ],
  },
  {  
    title: 'Service + Onboarding',
    pricePerMonth: {
      Annually: '$59/month',
      'Semi-Annually': '$69/month',
      Monthly: '$79/month',
    },
    benefits: [
      'Employee Management',
      'Hiring Document Storage',
      'Digital Employee Onboarding',
      'Multi User Access',
    ],
  },
  {
    title: 'StaffedUp Enterprise',
    benefits: [
      'Corporate Hiring Page',
      'Enterprise Admin Access',
      'Group Job Marketing',
    ],
  },
];
